// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1d0p0","location":"Header_location__2PJJL"};